var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medicaments"},[_c('ul',_vm._l((_vm.traitementMedicaments),function(m,i){return _c('li',{key:i},[_c('h6',[_vm._v(_vm._s(_vm.medicament(m.medoc))+" "),_c('small',[_vm._v("("+_vm._s(m.protocole)+")")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }